import { ApiError } from './apiClient';

export function humanizeJoinError(e: ApiError): string {
  switch (e.code) {
    case 'ROOM_NOT_FOUND': return 'Комната не найдена';
    case 'ROOM_ARCHIVED':  return 'Комната уже закрыта';
    case 'ROOM_IN_GAME':   return 'В комнате идёт раунд';
    case 'SOLO_ROOM':      return 'Это одиночная игра — войти нельзя';
    default:               return e.message || 'Не удалось войти в комнату';
  }
}
